/** Retired — legacy email/password page. Redirects to /login (Firebase Phone Auth).
 * Preserves the `?redirect=<path>` query string so guest-CTA links
 * from location articles ("Join to post here") still land the user
 * back on the article page after signing up. */
import { Navigate, useLocation } from "react-router-dom";
export default function Register() {
  const { search } = useLocation();
  return <Navigate to={`/login${search || ""}`} replace />;
}
